import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import ContextCard from 'components/molecules/Cards/ContextCard/ContextCard';

const StyledRelevancyContextCard = styled(ContextCard)`
  .RelevancyContextCard {
    &-button {
      min-width: 100%;
    }
  }
  
  &.RelevancyContextCard-inline {
    .Button {
      min-width: ${props => props.theme.layout(112)};
    }
  }
  
  ${ComponentStyles}
`;

StyledRelevancyContextCard.propTypes = {
  theme: PropTypes.object
};

export default StyledRelevancyContextCard;
